import { useCallback } from 'react';
import { useClient } from 'urql';

import {
  ScanToPayIdentifyTokenDocument,
  type ScanToPayIdentifyTokenQuery,
} from '../../graphql/ScanToPayIdentifyToken.generated';

// ────────────────────────────────────────────────────────────────────────────

/**
 * A hook for fetching the identify token.
 */
export const useScanToPayIdentifyToken = () => {
  const client = useClient();

  // ─── Queries ──────────────────────────────────────────────────────────────

  const fetchIdentifyToken = useCallback(async () => {
    const queryIdentifyToken = client.query<ScanToPayIdentifyTokenQuery>;

    const response = await queryIdentifyToken(
      ScanToPayIdentifyTokenDocument,
      {},
      { requestPolicy: 'network-only' },
    ).toPromise();

    const customerToken = response.data?.loyaltyProfile?.customerToken;

    if (customerToken?.__typename === 'LoyaltyAccessToken') {
      return { identifyToken: customerToken.token };
    }

    // Caught by the machine.
    throw new Error('Failed to fetch payment token');
  }, [client.query]);

  // ──────────────────────────────────────────────────────────────────────────

  return { fetchIdentifyToken };
};
